import { Typography } from 'antd'
import { useMockChartData } from '../useGenerateChartData'
import PlotComponent from './PlotComponent'

const { Paragraph } = Typography

const VolcanoPlot = () => {
  const { volcanoData } = useMockChartData()

  // from augustine - filtering volcano data
  const significant = volcanoData.filter(
    (d) => d.pValue < 0.05 && Math.abs(d.log2FoldChange) > 1
  )
  const nonSignificant = volcanoData.filter(
    (d) => !(d.pValue < 0.05 && Math.abs(d.log2FoldChange) > 1)
  )

  const xSignificant = significant.map((d) => d.log2FoldChange)
  const ySignificant = significant.map((d) => -Math.log10(d.pValue))

  const xNonSignificant = nonSignificant.map((d) => d.log2FoldChange)
  const yNonSignificant = nonSignificant.map((d) => -Math.log10(d.pValue))

  const allX = [...xSignificant, ...xNonSignificant]
  const allY = [...ySignificant, ...yNonSignificant]

  const maxY = Math.max(...allY)
  const minX = Math.min(...allX)
  const maxX = Math.max(...allX)

  return (
    <>
      <PlotComponent
        data={[
          {
            x: xNonSignificant,
            y: yNonSignificant,
            mode: 'markers',
            type: 'scatter', // volcano plot is a scatter plot
            name: 'Non-significant',
            marker: { color: 'gray', size: 6 },
            hovertemplate: '%{x}<br>p (log2): %{y}<extra></extra>',
          },
          {
            x: xSignificant,
            y: ySignificant,
            mode: 'markers',
            type: 'scatter',
            name: 'Significant',
            marker: { color: 'red', size: 6 },
            hovertemplate: '%{x}<br>p (log2): %{y}<extra></extra>',
          },
        ]}
        layout={{
          title: {
            text: 'Volcano Plot',
            font: { size: 24 },
          },
          xaxis: {
            title: { text: 'log2(Fold Change)', font: { size: 18 } },
            zeroline: true,
            range: [minX, maxX],
          },
          yaxis: {
            title: { text: '-log10(p-value)', font: { size: 18 } },
            zeroline: true,
            range: [0, maxY],
          },
        }}
        config={{ responsive: true }}
      />
      <Paragraph>
        <strong>Volcano Plot</strong>
      </Paragraph>
      <Paragraph>
        <strong>Data Points:</strong> {volcanoData.length} (Volcano)
      </Paragraph>
    </>
  )
}

export default VolcanoPlot
